import * as routes from "./routes";
import { ERouteMappingKeys, RouteMapping } from "./routes/routeKeys";

export interface IRedirectMapping {
  from: string;
  to: string;
}

/**
 * Route mapping object - defines all route groups and their lazy-loaded components
 * Routes are ordered by a best guess of priority
 * A new route will need a base path, a component and then to be spread here in ROUTE_MAP.
 * Any route can have as many sub-paths as needed and the BASE_PATH
 * is the route defined as the path in the object
 */
export const ROUTE_MAP: Record<ERouteMappingKeys, RouteMapping> = {
  ...routes.cloudGatewaysRoutes,
  ...routes.switchingRoutes,
  ...routes.wifiRoutes,
  ...routes.doorAccessRoutes,
  ...routes.accessoryTechRoutes,
  ...routes.whatsNewRoutes,
  ...routes.managedVoipRoutes,
  ...routes.specialDevicesRoutes,
  ...routes.howItWorksRoutes,
  ...routes.premiumIotRoutes,
  ...routes.powerTechRoutes,
  ...routes.identityRoutes,
  ...routes.cameraSecurityRoutes,
  ...routes.mobileRoutingRoutes,
  ...routes.networkStorageRoutes,
  ...routes.cloudKeysGatewaysRoutes,
  ...routes.downloadRoutes,
  ...routes.partnerHubRoutes,
  ...routes.uiCareRoutes,
  ...routes.ultraRoutes,
  ...routes.videoRecordersRoutes,
  ...routes.professionalIntegratorsRoutes,
  ...routes.siteSupportRoutes,
  ...routes.trustCenterRoutes,
};

// Redirect mappings (internal and external)
export const REDIRECT_MAP: IRedirectMapping[] = [
  // Console redirects
  { from: "/consoles", to: "/cloud-gateways" },
  {
    from: "/consoles/resource-calculator",
    to: "/cloud-gateways/resource-calculator",
  },
  // Redirects from physical security to camera security to match store
  {
    from: "/physical-security",
    to: "/camera-security",
  },
  {
    from: "/physical-security/bullet",
    to: "/camera-security/bullet",
  },
  {
    from: "/physical-security/dome-turret",
    to: "/camera-security/dome-turret",
  },
  {
    from: "/physical-security/ptz",
    to: "/camera-security/ptz",
  },
  {
    from: "/physical-security/video-recorders",
    to: "/camera-security/video-recorders",
  },
  {
    from: "/physical-security/door-access",
    to: "/door-access",
  },
  {
    from: "/physical-security/special-devices",
    to: "/camera-security/special-devices/compact-cameras",
  },
  {
    from: "/physical-security/special-devices/doorbells",
    to: "/camera-security/special-devices/doorbells",
  },
  {
    from: "/physical-security/special-devices/compact-cameras",
    to: "/camera-security/special-devices/compact-cameras",
  },
  {
    from: "/physical-security/special-devices/ai-enhancements",
    to: "/camera-security/special-devices/ai-enhancements",
  },
  {
    from: "/physical-security/special-devices/super-link",
    to: "/camera-security/special-devices/super-link",
  },
  {
    from: "/physical-security/special-devices/floodlight",
    to: "/camera-security/special-devices/floodlight",
  },

  // Integrations redirects
  { from: "/phone-system", to: "/integrations/managed-voip" },
  { from: "/integrations", to: "/integrations/managed-voip" },
  {
    from: "/integrations/premium-iot",
    to: "/integrations/premium-iot/ev-charging",
  },
  {
    from: "/integrations/cloud-keys-gateways",
    to: "/integrations/cloud-keys-gateways/control-plane-options",
  },
  {
    from: "/integrations/power-tech",
    to: "/integrations/power-tech/ups-solutions",
  },

  // Accessory redirects
  { from: "/unifi-accessories", to: "/integrations/accessory-tech" },
  { from: "/accessory-tech", to: "/integrations/accessory-tech" },
  {
    from: "/accessory-tech/cloud-keys-gateways",
    to: "/integrations/cloud-keys-gateways/control-plane-options",
  },

  // Download redirects
  {
    from: "/download/unifi/unifi-os-native/download-started",
    to: "/download/unifi/download-started",
  },
  {
    from: "/download/unifi/unifi-os/download-started",
    to: "/download/unifi/download-started",
  },

  // External redirects (UISP)
  { from: "/uisp", to: "https://uisp.com" },
  {
    from: "/uisp/ptp-bridging",
    to: "https://uisp.com/wireless/airfiber-and-ltu/airfiber",
  },
  {
    from: "/uisp/multipoint",
    to: "https://uisp.com/wireless/airfiber-and-ltu/ltu",
  },
  { from: "/uisp/wired-technologies", to: "https://uisp.com/wired" },
  { from: "/uisp/accessories", to: "https://uisp.com/accessories" },
  { from: "/uisp/*", to: "https://uisp.ui.com" },
];
